export default {
  CENTYL: 'Centyl', TEN: 'Ten', STANIN: 'Stanin', STEN: 'Sten',
};
